import i18n from 'i18n/config';

export default {
  ORDINARY: {
    value: 'ORDINARY',
    text: i18n.t('Ordinary'),
    label: 'Ordinary',
  },
  EXTRAORDINARY: {
    value: 'EXTRAORDINARY',
    text: i18n.t('Extraordinary'),
    label: 'Extraordinary',
  },
  ORDINARY_EXTRAORDINARY: {
    value: 'ORDINARY_EXTRAORDINARY',
    text: i18n.t('OrdinaryAndExtraordinary'),
    label: 'OrdinaryAndExtraordinary',
  },
  UNIVERSAL: {
    value: 'UNIVERSAL',
    text: i18n.t('Universal'),
    label: 'Universal',
  },
};
